import { ILanguage } from "../types";

export const es: ILanguage = {
  translation: {
    root: {
      customize: "Personalizar",
      businessAccount: "Cuenta comercial",
      verificationStatus: "Estado de verificación",
      companyInformation: "Información de la empresa",
      note: "Nota",
      businessName: "Nombre comercial*",
      enterBusinessName: "Ingrese el nombre del negocio",
      registrationNumber: "Reg. De la empresa. ",
      registrationNumberPlaceholder: "Ingrese el número de registro",
      taxVat: "Registro de impuestos/IVA No.",
      vatPlaceholder: "Ingrese el número de registro de impuestos/IVA",
      registeredAddress: "Dirección registrada*",
      tradingAddress: "Dirección comercial*",
      mode: "Modo",
      comments: "Comentarios",
      sameAsRegisteredAddress: "Igual que la dirección registrada",
      billingInformation: "Información de facturación",
      billingPhoneNo: "Billing Teléfono No.*",
      phonePlaceholder: "Ingrese el número de teléfono",
      billingEmail: "Correo electrónico de facturación*",
      emailPlaceholder: "Ingrese el correo electrónico de facturación",
      driverDetails: "Detalles del conductor",
      customerVerificationStatus: "Estado de verificación del cliente:",
      enterNationalInsuranceNumber: "Ingrese el número de seguro nacional",
      enterYourProfession: "Ingrese su profesión",
      enterDriving: "Ingrese a conducir",
      profileImage: "imagen de perfil",
      middleName: "Segundo nombre",
      middleNameLabel: "Segundo nombre",
      enterMiddleName: "Ingrese segundo nombre",
      number: "Número",
      image: "Imagen",
      uploadBack: "Cargar hacia atrás",
      uploadFront: "Cargar frente",
      issuedBy: "Expedido por",
      document: "Documento",
      selectDocument: "Seleccionar documento",
      addFile: "Agregar archivo",
      noDataFound: "No se encontraron datos",
      noDocumentsFound: "No se encontraron documentos",
      documentUpdatedAt: "Documento actualizado en",
      editExpiryDate: "Editar fecha de vencimiento",
      selectExpiryDate: "Seleccione la fecha de vencimiento",
      selectExpiryDateUpload:
        "Seleccione una fecha de vencimiento antes de cargar.",
      status: "Estado",
      images: "Imágenes",
      profession: "Profesión",
      nationality: "Nacionalidad",
      driving: "Conduciendo",
      listOfDocumentsUploaded: "Lista de documentos cargados",
      listOfRequiredDocumentsUploaded:
        "Lista de documentos requeridos cargados",
      documentType: "Tipo de documento",
      documentName: "Nombre del documento",
      expiryDate: "Fecha de vencimiento",
      confirmDelete: "Confirmar eliminar",
      actions: "Comportamiento",
      completed: "Terminado",
      pending: "Pendiente",
      documentDeleteConfirmMsg:
        "¿Estás seguro de que quieres eliminar este documento?",
      address: "DIRECCIÓN",
      useRegisteredAddress: "Utilice la dirección registrada",
      billingEmailAddress: "Dirección de correo electrónico de facturación*",
      billingEmailLabel: "Dirección de correo electrónico de facturación",
      accountNumber: "Número de cuenta",
      firstName: "Nombre de pila*",
      firstNameLabel: "Nombre de pila",
      lastName: "Apellido*",
      lastNameLabel: "Apellido",
      contactEmail: "Dirección de correo electrónico de contacto*",
      emailLabel: "Dirección de correo electrónico",
      contactPhone: "Contacto con el número de teléfono*",
      registeredAddressCaps: "Dirección registrada",
      tradingAddressCaps: "Dirección comercial",
      billingInformationCaps: "INFORMACIÓN DE FACTURACIÓN",
      customerContactCaps: "Contacto con el cliente",
      contactEmailInvalid: "Ingrese un correo electrónico de contacto válido.",
      typeAddress: "Tipo de dirección",
      taxFees: "Impuestos y tarifas",
      vatTax: "IVA/impuesto",
      registrationNum: "Número de registro",
      drivingLicenceNumber: "Número de licencia de conducir",
      invalidPhoneNumber: "Número de licencia de conducir",
      onStartEmail:
        "Le hemos enviado un correo electrónico sobre cómo comenzar.",
      emailNotSeen:
        'Si no ve el correo electrónico en unos minutos, consulte su "correo basura" o "carpeta de spam.',
      registerNow: "Regístrate ahora",
      email: "Correo electrónico",
      thankYou: "Gracias",
      pickUpLocation: "Lugar de recogida ",
      returnLocation: "Lugar de devolución *",
      pickUpDate: "Fecha de recogida *",
      pickUpTime: "Hora de recogida *",
      invalidPickupLeadTime: "La fecha/hora de recogida seleccionada está fuera del periodo de reserva permitido",
      dropOffDate: "Fecha de devolución *",
      searchVehicles: "Buscar vehículos",
      chooseLocation: "Ingrese una ubicación o código postal",
      vehicleGallery: "Galería de vehículos",
      privacyPolicy: "Política de privacidad",
      termsAndConditions: "Términos y condiciones",
      dropOffTime: "Hora de devolución *",
      noVehiclesFound:
        "No se encontraron vehículos que coincidan con los criterios seleccionados",
      noRecordFound: "Lo sentimos, ¡no se encontraron registros coincidentes!",
      vehicles: "Vehículos",
      endDate: "Fecha de finalización",
      startDate: "Fecha de inicio",
      past: "Pasado",
      search: "Buscar",
      upcoming: "Próximo",
      current: "Actual",
      all: "Todos",
      more: "Más",
      toBeAssigned: "Por asignar",
      ref: "ref",
      reservation: "Reservación",
      booking: "Reserva",
      pricingSummary: "Resumen de precios",
      bookingSummary: "Resumen de reserva",
      subscriptionVehicle: "Vehículo de suscripción",
      insurance: "Seguro",
      addons: "Complementos",
      protectionPlan: "Plan de protección",
      initialRental: "Renta inicial",
      enrollmentFee: "Tarifa de inscripción",
      quantity: "Cantidad",
      subscriptionPrice: "Precio de suscripción",
      weekly: "Semanal",
      monthly: "Mensual",
      on: "En",
      numberOfDoors: "númeroDePuertas",
      numberOfSeats: "númeroDeAsientos",
      transmission: "transmisión",
      fuelType: "tipoDeCombustible",
      week: "Semana",
      day: "Día",
      hour: "Hora",
      month: "Mes",
      gropu1Icon: "icono grupo1",
      vatInclusive: "IVA INCLUIDO",
      vat: "IVA",
      rental: "Renta",
      speedometer: "velocímetro",
      available: "Disponible",
      priceLowToHigh: "Precio de menor a mayor",
      priceHighToLow: "Precio de mayor a menor",
      weHaveSmartCars: "Tenemos autos inteligentes",
      keylessSupport:
        "Brindamos soporte de entrada sin llave con nuestros autos inteligentes",
      keylessVehicles: "Ver vehículos sin llave",
      duration: "Duración",
      swapsAllowed: "Cambios permitidos",
      enrollmentAmount: "Monto de inscripción",
      subscriptionAmount: "Monto de suscripción",
      mileageLimit: "Límite de kilometraje",
      unlimited: "Ilimitado",
      weeks: "Semanas",
      months: "Meses",
      pricePerExtraMile: "Precio por milla extra",
      insurancePolicy: "Póliza de seguro",
      removeSubscription: "Eliminar suscripción",
      noGroupFound: "¡No se encontraron grupos con los criterios dados!",
      vehicleTypeIcon: "icono tipo de vehículo",
      min: "Mín.",
      selected: "Seleccionado",
      vehiclesSelected: "Vehículos seleccionados",
      selectVehicles: "Seleccionar vehículos",
      personalDetails: "Detalles personales",
      selectAddons: "Seleccionar complementos",
      continue: "Continuar",
      locationSurcharge: "Recargo por ubicación",
      onTotalRentalAmount: "Sobre el monto total de renta",
      oneWayFee: "Tarifa de una vía",
      oneWayRentalCharge: "Cargo de renta de una vía",
      total: "Total",
      firstMonthTotal: "Total del primer mes",
      firstWeekTotal: "Total de la primera semana",
      depositPayable: "Depósito (pagadero en la recogida)",
      deposit: "Depósito",
      insuranceCaps: "SEGURO",
      customAddon: "complemento personalizado",
      chooseAPolicy: "Elige una póliza",
      rate: "Tarifa",
      typeOfValet: "Tipo de valet",
      nonNegotiable: "No negociable",
      selectValet: "Seleccionar valet",
      collectionAddress: "Dirección de recogida",
      remove: "Eliminar",
      deliveryAddress: "Dirección de entrega",
      additionalInformation: "Información adicional",
      confirmBooking: "Confirmar reserva",
      proceed: "Proceder",
      getQuote: "Obtener cotización",
      for: "para",
      agreeWithTermsAndConditions:
        "Estoy de acuerdo con los términos y condiciones",
      selectCostCenter: "Seleccionar centro de costos para la reserva",
      action: "Acción",
      name: "Nombre",
      enterDrivingLicenceNumber: "Introducir número de licencia de conducir",
      enterLastName: "Introducir apellido",
      enterFirstName: "Introducir nombre",
      enterYourMail: "Introduce tu correo electrónico",
      emailAsterisk: "Correo electrónico*",
      quoteGeneratedCaps: "COTIZACIÓN GENERADA",
      updated: "actualizado",
      rentalCharges: "Cargos por renta",
      totalPayableAmount: "Monto total a pagar",
      payMinimumAmount: "Pagar monto mínimo",
      dueAmountPaidWhilePickup:
        "Monto adeudado pagado al momento de la recogida",
      payOnCollection: "Pagar al recoger",
      CardAuthorization:
        "La tarjeta será autorizada ahora pero el monto se cargará cuando",
      starts: "comience",
      confirm: "Confirmar",
      payAtTimeOfPickup: "ahora y pagar al momento de la recogida",
      payFullAmountNow: "Pagar el monto total ahora",
      payFullAmountRightAway: "Pagar el monto total de inmediato",
      FutureChargesRelatedToOngoingBooking:
        "Los cargos futuros relacionados con la reserva en curso se cobrarán a este método de pago",
      saveThisCardForFutureInvoices:
        "Guardar esta tarjeta para futuros pagos de facturas {{bookingSyntax}}",
      payLater: "Pagar después",
      creditLimitAssigned:
        "El límite de crédito asignado se usará para este pago",
      CreditsAgainstBooking: "Los créditos se usarán contra esta reserva",
      useCreditNoteBalance: "Usar saldo de nota de crédito",
      telNo: "Tel.",
      vatNo: "NIF",
      customer: "Cliente",
      emailAddress: "Dirección de correo electrónico",
      phoneNumber: "Número de teléfono",
      dateCreated: "Fecha de creación",
      poNumber: "Número de orden",
      dateTime: "Fecha y hora",
      dropOffLocation: "Lugar de entrega",
      contractHire: "Alquiler por contrato",
      subscription: "Suscripción",
      charges: "Cargos",
      enrollmentFees: "Tarifas de inscripción",
      na: "N/D",
      grandTotal: "Total general",
      rentalPrice: "Precio de renta",
      daysProRated: "días prorrateados",
      locationSurcharges: "Recargos por ubicación",
      ofTotalRentalAmount: "del monto total de la renta",
      nextBilling: "Próxima facturación",
      subTotal: "Subtotal",
      discount: "Descuento",
      discountedPrice: "Precio con Descuento",
      description: "DESCRIPCIÓN",
      descriptionLabel: "Descripción",
      thisIsA: "Esto es una",
      exemptedBooking: "reserva exenta",
      thisIstestCourtsey: "Esto es una prueba/cortesía",
      isCalculatedAgainst: "se calcula contra",
      priceAndSelectedAddons:
        "Precio y complementos seleccionados (excepto seguro y depósito)",
      recurringWeeklyMonthlyInvoice:
        "Se generará automáticamente una factura recurrente semanal/mensual.",
      additionalNote: "Nota adicional",
      payableAtVehicleCollection:
        "Pagadero al momento de la recogida del vehículo",
      purchaseOrderUpdated:
        "número de orden de compra actualizado correctamente",
      proceedToPay: "Proceder a pagar",
      searchResults: "Resultados de búsqueda",
      subscriptions: "Suscripciones",
      contractHireVehicleWeeklyMonthly: "Alquiler de vehículo por semana/mes",
      subscribeVehicleWeeklyMonthly: "Suscribirse al vehículo por semana/mes",
      contractNow: "Contratar ahora",
      subscribeNow: "Suscribirse ahora",
      backToBookingCategorySelection:
        "Volver a la selección de categorías de reserva.",
      accountVerification: "Verificación de cuenta",
      profileNotVerifiedMessage:
        "Su perfil no ha sido verificado. Por favor, contacte a su operador para completar el proceso de verificación y continuar.",
      update: "Actualizar",
      reference: "Referencia",
      companyRegistrationNumber: "Número de registro de la empresa",
      availableFrom: "Disponible desde",
      paellaDish: "Plato de paella",
      vehicleCatalogues: "Catálogos de Vehículos",
      vehicleDetails: "Detalles del Vehículo",
      verification: "Verificación",
      protectionPlans: "Planes de protección",
      authorisedSignatory: "Firmante Autorizado",
      item: "Artículo",
      price: "Precio",
      unitPrice: "Precio unitario",
      vehicleSpecification: "Especificación del vehículo",
      model: "Modelo",
      color: "Color",
      bodyType: "Tipo de carrocería",
      tankCapacity: "Capacidad del tanque",
      interiorColor: "Color interior",
      seats: "Asientos",
      doors: "Puertas",
      whatsIncluded: "Qué está incluido",
      timeVehicleSwap: "tiempo para cambiar de vehículo",
      contractualDetails: "Detalles contractuales",
      longerSubscribeSaveMore: "Cuanto más tiempo te suscribas, más ahorras",
      tailorSubscriptionToNeeds: "Adapta tu suscripción a tus necesidades",
      easyManagementOnline: "Gestión fácil y en línea",
      SwapCarAndCancel: "Cambia el coche o cancela en cualquier momento",
      customizeYourContract: "Personaliza tu contrato",
      selectPlan: "Seleccionar plan",
      selectTenure: "Seleccionar duración",
      tentativeStartDate: "Fecha de inicio tentativa",
      selectDate: "Seleccionar fecha",
      selectTime: "Seleccionar hora",
      contractSummary: "Resumen del contrato",
      subscriptionChargesLabel: "Cargos de suscripción",
      initialRentalPayment: "Pago inicial de alquiler",
      continueToPersonalDetails: "Continuar a datos personales",
      noAvailableAddonsFound:
        "No se encontraron complementos disponibles que coincidan con sus criterios de búsqueda",
      nationalInsuranceNumber: "Número de seguro nacional",
      updateQuote: "Actualizar cotización",
      driverNotAvailable:
        "El conductor no está disponible, por favor contacte al operador de alquiler",
      selectDeliverySlot: "Seleccione una franja de entrega",
      wantDelivered: "¿Desea que se entregue?",
      verifyYourLicenceCaps: "VERIFIQUE SU LICENCIA",
      validateAllFieldsForLicenceCheck:
        "Por favor valide o introduzca los siguientes datos para verificar la licencia. Todos los campos son obligatorios.",
      postCode: "Código Postal",
      thisAgreementAllows: "Este acuerdo permite",
      leftoverAgreement:
        "a nuestro socio de seguros realizar verificaciones de su licencia de conducir y pasar sus datos a aseguradoras y otras terceras partes (Coastr) para la gestión de su alquiler, póliza, etc. ¿Acepta y consiente lo anterior?",
      verifyLicence: "Verificar Licencia",
      licenceCheckingInProgress: "Verificación de licencia en progreso",
      checkingInProgress:
        "Esto puede tardar hasta 2 minutos, por favor espere y no cierre el navegador",
      licenceCheckingFailed: "Fallo en la verificación de la licencia",
      checkForCorrectDetails:
        "Por favor revise si ha introducido los datos correctos.",
      tryAgainLater: "Si el problema persiste, intente nuevamente más tarde.",
      licenceCheckedSuccessfully: "Licencia verificada con éxito",
      licenceSummaryAdded: "Resumen de licencia agregado al perfil del cliente",
      creditScore: "Puntaje de crédito",
      lastChecked: "Última verificación",
      recheckCreditScore: "VERIFICAR PUNTAJE NUEVAMENTE",
      checkCreditScore: "VERIFICAR PUNTAJE",
      proceedToPayment: "Proceder al pago",
      paymentOverview: "Resumen de pago",
      schedule: "Horario",
      contractDetails: "Detalles del contrato",
      plan: "Plan",
      swaps: "Cambios",
      payableDeposit: "Depósito a pagar",
      customerVerification: "Verificación del cliente",
      provideAdditionalDetails:
        "Por favor, proporcione los siguientes detalles adicionales en la sección de cuenta para crear la reserva",
      profilePhoto: "Foto de perfil",
      submitYourRequest:
        "Una vez hecho, envíe su solicitud para su aprobación haciendo clic en el botón de enviar a continuación",
      submit: "Enviar",
      uploadLicenceImages: "Subir imágenes de licencia",
      add: "Añadir",
      uploadFrontBackLicence:
        "Suba la imagen frontal y trasera de la licencia. Formatos soportados: .png, .jpeg, .jpg!",
      uploadLicenceImage: "Subir imagen de licencia",
      authority: "Autoridad",
      drivingLicenceExpiryDate:
        "Fecha de vencimiento de la licencia de conducir",
      licenceNumber: "Número de licencia",
      preview: "Vista previa",
      addOn: "Complemento",
      contact: "Contacto",
      selectSlot: "Seleccionar ranura",
      deliveryType: "Tipo de entrega",
      experience: "Experiencia",
      type: "Tipo",
      bookATestDrive: "Reservar una prueba de manejo",
      selectASlot: "Selecciona una franja horaria",
      selectDateTimeSlot: "Seleccionar fecha y hora",
      vehicleNotAvailable: "Vehículo no disponible para la fecha seleccionada",
      selectDifferentDate: "Por favor seleccione una fecha diferente",
      selectCar: "Seleccionar un coche",
      availableNow: "Disponible ahora",
      new: "Nuevo",
      phone: "Teléfono",
      customerDetails: "Detalles del cliente",
      dealershipAddress: "Dirección del concesionario",
      dealership: "Concesionario",
      bookingTime: "Hora de reserva",
      bookingType: "Tipo de reserva",
      details: "Detalles",
      your: "Su",
      confirmation: "Confirmación",
      selectDealership: "Seleccionar concesionario",
      testDriveRequested: "Prueba de manejo solicitada",
      testDrive: "Prueba de manejo",
      mobileNumber: "Número de móvil",
      drivingLicenseNumber: "Número de licencia de conducir",
      enterLicenseNumber: "Introducir número de licencia",
      requestTestDrive: "Solicitar prueba de manejo",
      slot: "ranura",
      vehicle: "Vehículo",
      selectSubsctiption: "SELECCIONAR SUSCRIPCIÓN",
      pricesShownOnSelectedDuration:
        "Los precios mostrados se basan en la duración seleccionada",
      priceComparison: "Comparación de precios",
      oneTime: "Una vez",
      subscriptionStartsAt: "La suscripción comienza en",
      paymentProcessing: "Procesando el pago",
      pleaseWait: "Por favor, espere",
      paymentComplete: "Pago completado",
      paymentInProgress: "Pago en curso",
      atleastUploadOne: "Sube al menos uno",
      upload: "Subir",
      uploadServiceNotAvailable: "Servicio de carga no disponible. Por favor, inténtelo de nuevo.",
      uploading: "Subiendo...",
      atDealership: "En el concesionario",
      atHome: "En casa",

      enterYourEmailPassword:
        "Ingrese su correo electrónico y contraseña para iniciar sesión",
      enterMailHere: "Ingrese su correo electrónico aquí",
      required: "Requerido",
      password: "Contraseña",
      reset: "Restablecer",
      otpForPasswordReset:
        "Recibirá un OTP para restablecer la contraseña en su correo electrónico",
      sendOtp: "Enviar OTP",
      loginInstead: "Iniciar sesión en su lugar",
      verifyOtp: "Verificar OTP",
      otp: "OTP",
      otpSentToEmail: "El OTP ha sido enviado a su correo electrónico",
      enterOtp: "Ingrese OTP",
      enterOtpHere: "Ingrese OTP aquí",
      verify: "Verificar",
      setNewPassword: "Establecer nueva contraseña",
      eightCharLong: "Debe tener 8 caracteres",
      reenterPassword: "Vuelva a ingresar la contraseña aquí",
      signInAs: "Iniciar sesión como",
      as: "Como",
      selectAccountToProceed: "Seleccione una cuenta para continuar",
      personalAccount: "Cuenta personal",
      asBusinessCustomer: "Como cliente empresarial",
      asDriver: "Como conductor",
      enterPassword: "Ingrese la contraseña aquí",
      registerAs: "Registrarse como",
      individual: "Individual",
      business: "Empresa",
      operatorMandatedCustomerCheck:
        "El operador ha requerido una verificación del cliente antes de tener una reserva confirmada. Por favor, espere la aprobación; se le notificará.",
      createAccount: "Crear cuenta",
      emailedHowToGetStarted:
        "Le hemos enviado un correo con instrucciones para comenzar.",
      ifDontSeeEmail:
        "Si no ve el correo en unos minutos, revise su carpeta de spam o correo no deseado.",
      previousVehicleDetails: "Detalles del vehículo anterior",
      registration: "Matrícula",
      makeModel: "Marca/Modelo",
      vin: "Número VIN",
      driverAssigned: "Conductor asignado",
      currentVehicleDetails: "Detalles del vehículo actual",
      priceGroup: "Grupo de precio",
      unlimitedMileage: "Kilometraje ilimitado",
      paymentStatus: "Estado del pago",
      invoiceNumber: "Número de factura",
      deliveryDetails: "Detalles de entrega",
      collectionDetails: "Detalles de recogida",
      coiDetails: "Detalles COI",
      policyName: "Nombre de la póliza",
      planName: "Nombre del plan",
      policyNumber: "Número de póliza",
      provider: "Proveedor",
      vehicleSwapDetails: "Detalles de intercambio de vehículo",
      swapMyCar: "Cambiar mi coche",
      NoOfSwapsAllowed: "Cantidad de intercambios permitidos",
      NoOfSwapsAvailed: "Cantidad de intercambios utilizados",
      NoOfSwapsRemaining: "Cantidad de intercambios restantes",
      swapRequestHistory: "HISTORIAL DE SOLICITUDES DE INTERCAMBIO",
      requestedOn: "SOLICITADO EL",
      swapDate: "FECHA DE INTERCAMBIO",
      oldVehicle: "Vehículo anterior",
      newVehicle: "Vehículo nuevo",
      addonsDetails: "Detalles de complementos",
      paymentDetails: "Detalles del pago",
      billingPeriod: "Período de facturación",
      creationDate: "Fecha de creación",
      invoiceType: "Tipo de factura",
      regular: "Regular",
      depositDetails: "Detalles del depósito",
      amount: "Monto",
      totalPaidAmount: "Monto total pagado",
      cancellationCharges: "Cargos de cancelación",
      totalRefundAmount: "Monto total reembolsado",
      anUnpaid: "un impago",
      aPartiallyPaid: "un pago parcial",
      thisIs: "Esto es",
      pleaseContactUs: "Por favor contáctenos para más consultas",
      reasonToCancelTheBooking:
        "Por favor seleccione una razón para cancelar la reserva",
      enterTheReason: "Ingrese la razón",
      dismiss: "Descartar",
      selectVehicle: "Seleccionar vehículo",
      bookingConfirmationInProgress: "Confirmación de reserva en curso",
      pleaseProvideTheReason: "Por favor proporcione la razón",
      quote: "Cotización",
      management: "Gestión",
      pickupDateTimePassed:
        "¡La fecha/hora de recogida ha pasado! o es una reserva sin cargo",
      profileRejectedOrPending: "Tu perfil ha sido rechazado o está pendiente",
      testDriveAgreement: "Acuerdo de prueba de manejo",
      rentalAgreement: "Contrato de alquiler",
      contractHireAgreement: "Acuerdo de contrato de alquiler",
      subscriptionAgreement: "Acuerdo de suscripción",
      zeroChargeBooking:
        "Reservas sin cargo solo pueden ser confirmadas por el operador de alquiler",
      pickupDateTimeInPast: "La fecha/hora de recogida está en el pasado",
      creditNoteSummary: "Resumen de nota de crédito",
      customerName: "Nombre del cliente",
      customerEmail: "Correo electrónico del cliente",
      creditNoteRef: "Referencia de nota de crédito",
      invoiceRef: "Referencia de factura",
      totalAmount: "Monto total",
      amountAdjustedRefunded: "Monto ajustado/reembolsado",
      amountAvailable: "Monto disponible",
      adjustments: "Ajustes",
      particulars: "Detalles",
      adjustedToInvoice: "Ajustado a la factura",
      adjustedAt: "Ajustado en",
      creditNotes: "Notas de crédito",
      availableBalance: "Saldo disponible",
      searchCreditNoteId: "Buscar ID de nota de crédito",
      active: "Activo",
      exhausted: "Agotado",
      creditNoteId: "ID de nota de crédito",
      dateGenerated: "Fecha generada",
      amountRefunded: "Monto reembolsado",
      amountRemaining: "Monto restante",
      dashboard: "Panel",
      activeVehiclesCount: "Cantidad de vehículos activos",
      totalActiveBookings: "Total de reservas activas",
      totalVehicles: "Total de vehículos",
      vehicleChecks: "Revisiones de vehículo",
      inProgressBookings: "Reservas en curso",
      vehicleChecksCompleted: "Revisiones de vehículo completadas",
      vehicleChecksPending: "Revisiones de vehículo pendientes",
      dailyBalance: "Balance diario",
      totalOutstanding: "Total pendiente",
      UnpaidInvoices: "Cantidad de facturas impagas",
      regularInvoices: "Facturas regulares",
      sundryInvoices: "Facturas diversas",
      addNewDriver: "Agregar nuevo conductor",
      phoneNo: "Teléfono",
      drivingLicenceImage: "Imagen del permiso de conducir",
      licenceIssuedBy: "Licencia emitida por",
      licenceExpiryDate: "Fecha de vencimiento de la licencia",
      drivingLicenceIssueDate: "Fecha de emisión de licencia de conducir",
      pcoIssueDate: "Fecha de emisión de la licencia PCO del conductor",
      dateOfBirth: "Fecha de nacimiento",
      taskDetailsNotFound: "Detalles de la tarea no encontrados.",
      bookingRef: "Ref. de reserva",
      rateYourExperience: "Califica tu experiencia",
      driverInformation: "Información del conductor",
      saveDrivers: "Guardar conductores",
      expiry: "Vencimiento",
      areYouSureDriver: "¿Está seguro de que desea eliminar a este conductor?",
      drivers: "Conductores",
      noDriverFound: "¡Lo sentimos, no se encontraron conductores!",
      invoices: "Facturas",
      searchInvoiceId: "Buscar ID de factura",
      unpaid: "Impaga",
      paid: "Pagada",
      void: "Anulada",
      invoiceId: "ID de factura",
      invoiceDate: "Fecha de factura",
      balanceDue: "Saldo adeudado",
      dueDate: "Fecha de vencimiento",
      invoiceSummary: "Resumen de factura",
      invoice: "Factura",
      sundry: "Diversos",
      addPayment: "Agregar pago",
      customerPhoneNumber: "Teléfono del cliente",
      invoiceReference: "Referencia de factura",
      period: "Periodo",
      invoiceVoidedBy: "Factura anulada por",
      invoicePeriod: "Periodo de factura",
      invoiceStatus: "Estado de factura",
      invoiceAmount: "Monto de factura",
      amountDue: "Monto adeudado",
      generatedAt: "Generado en",
      vehicleRentalCharges: "Cargos de alquiler de vehículo",
      refundable: "Reembolsable",
      date: "Fecha",
      thisIsTestCourtsey: "Esto es una prueba/agradecimiento",
      invoicesConsolidated: "Facturas consolidadas",
      payments: "Pagos",
      exempted: "Exento",
      pleaseLoginFirst: "Por favor inicie sesión primero",
      account: "Cuenta",
      tracking: "Seguimiento",
      uploadImages: "Subir imágenes",
      updateVehicleState: "Actualizar estado del vehículo",
      vehicleImage: "Imagen del vehículo",
      fuelStatus: "Estado de combustible",
      batteryStatus: "Estado de batería",
      odometerReading: "Lectura del odómetro",
      nextServiceDetails: "Detalles del próximo servicio",
      serviceType: "Tipo de servicio",
      serviceStatus: "Estado del servicio",
      appointmentDate: "Fecha de cita",
      estdCompletionDate: "Fecha estimada de finalización",
      serviceProviderName: "Nombre del proveedor de servicio",
      serviceProviderAddress: "Dirección del proveedor",
      notesForDriver: "Notas para el conductor",
      exteriorDamages: "Daños exteriores",
      interiorDamages: "Daños interiores",
      generalChecks: "Revisiones generales",
      accessoriesChecks: "Revisiones de accesorios",
      chooseFuelLevel: "Elija nivel de combustible",
      lastReported: "Última actualización",
      circumstance: "Circunstancia",
      title: "Título",
      damageKind: "Tipo de daño",
      damageArea: "Área de daño",
      referenceNumber: "Número de referencia",
      damageDetail: "Detalle del daño",
      addImage: "Agregar imagen",
      addImages: "Agregar imágenes",
      done: "Hecho",
      searchExistingDriver: "Buscar conductor existente",
      success: "Éxito",
      assignDriver: "Asignar conductor",
      plate: "Matrícula",
      unassigned: "No asignado",
      assigned: "Asignado",
      make: "Marca",
      vehicleAppearOnceAssigned: "¡Los vehículos aparecerán una vez asignados!",
      searchVehicle: "Buscar vehículo",
      trackingHistoryHrs: "Historial de seguimiento (horas)",
      telemetryDevice: "Dispositivo telemétrico",
      lastLocation: "Última ubicación",
      latitude: "Latitud",
      longitude: "Longitud",
      forSelectedPeriod: "Para el periodo seleccionado –",
      milesDriven: "Millas recorridas",
      engineHours: "Horas de motor",
      fuelUsageLitres: "Consumo de combustible (litros)",
      stoppagehours: "Horas de parada",
      chargeStatus: "Estado de carga",
      fuelUsage: "Consumo de combustible",
      batteryLevel: "Nivel de batería",
      speedLimit: "Límite de velocidad",
      invalidEmailAddress: "Correo electrónico inválido",
      unableLoadCompanyDetails:
        "No se pueden cargar los detalles de la empresa",
      bookingConfirmationProgress: "Confirmación de reserva en progreso...",
      doNotHitBack:
        "Por favor no use atrás, cancelar o cierre el navegador. Este proceso puede tardar hasta 2 minutos.",
      summary: "Resumen",

      addNew: "Agregar nuevo",
      street: "Calle",
      city: "Ciudad",
      regionState: "Región/Estado",
      country: "País",
      zipPostalCode: "Código postal",
      cardAuthorizeNowButAmountLater:
        "La tarjeta se autorizará ahora pero el monto se descontará al iniciar la reserva",
      saveThisCardForFutureInvoicesBooking:
        "Guardar esta tarjeta para pagar futuras facturas de esta reserva.",
      confirmBookingPayLater: "Confirmar reserva, pagar después",
      confirmBookingAndPayAtPickup: "Confirmar ahora y pagar al recoger",
      bookingReferenceNumber: "Número de Referencia de Reserva",
      pickupDetails: "Detalles de Recogida",
      dropoffDetails: "Detalles de Entrega",
      to: "Hasta",
      bookingReference: "Referencia de Reserva",
      invoiceStartDate: "Fecha de Inicio de Factura:",
      invoiceEndDate: "Fecha de Finalización de Factura:",
      availableAtLocations: "Disponible en Ubicaciones",
      benefits: "Beneficios",
      passportNumber: "Número de Pasaporte",
      enterPassportNumber: "Ingrese su número de pasaporte",
      vehicleSwapRequest: "Solicitud de intercambio de vehículo",
      checkVehicleAvailability: "Comprobar disponibilidad de vehículos",
      pleaseSelectDateAndSearch:
        "Por favor seleccione fecha y haga clic en buscar para disponibilidad de vehículos",
      noVehicleFoundForSelectedDate:
        "No se encontró vehículo para la fecha seleccionada",
      notes: "Notas",
      writeYourNoteHere: "Escriba su nota aquí",
      updateRequest: "Actualizar solicitud",
      generateRequest: "Generar solicitud",
      cancelRequest: "Cancelar solicitud",
      operator: "Operador",
      you: "Usted",
      maximum: "Máximo",
      imagesAreAllowed: "se permiten subir imágenes.",
      dragAndDropFile: "Arrastre y suelte un archivo o haga clic",
      areAllowed: "están permitidos",
      cancelBooking: "Cancelar reserva",
      booked: "Reservado",
      organisation: "Organización",
      vatNumber: "Número de IVA",
      sort: "Ordenar",
      DELETE_DRIVER_DESCRIPTION:
        "¿Estás seguro de que deseas eliminar al conductor?",
      driverActions: {
        "Are you sure you want to delete the driver?":
          "¿Estás seguro de que deseas eliminar al conductor?",
        "Delete Driver": "Eliminar conductor",
      },
      currentInvoiceStatus: {
        PAID: "PAGADO",
        UNPAID: "NO PAGADO",
        VOID: "ANULADO",
        "PARTIALLY PAID": "PAGADO PARCIALMENTE",
        DRAFT: "BORRADOR",
      },
      currentBookingStatus: {
        CANCELLED: "CANCELADO",
        COMPLETED: "COMPLETADO",
        "CONFIRMATION IN PROCESS": "CONFIRMACIÓN EN PROCESO",
        CONFIRMED: "CONFIRMADO",
        "IN PROGRESS": "EN PROCESO",
        QUOTE: "COTIZACIÓN",
        DRAFT: "BORRADOR",
        "REQUIRES APPROVAL": "REQUIERE APROBACIÓN",
        DECLINED: "DECLINADO"
      },
      minBookingDurationMessage:
        "La duración mínima de la reserva es de {{hours}} horas. Por favor ajusta la fecha y hora de recogida o devolución en consecuencia.",
      maxBookingDurationMessage:
        "La duración máxima de la reserva es de {{days}} días. Por favor ajusta la fecha y hora de recogida o devolución en consecuencia.",
      usevaletTypes: {
        Delivery: "Entrega",
        Collection: "Recogida",
        "Delivery and Collection": "Entrega y Recogida",
      },
      selectCollectionSlot: "Selecciona una franja de recogida",
      driverUnavailableNote:
        "Nota: El conductor no está disponible, por favor contacta al operador de alquiler.",
      cancellationReasons: {
        "Requirement changed": "Cambió la necesidad",
        Price: "Precio",
        Other: "Otro",
      },
      imagePreview: "Vista previa de imagen",
      markDamage: "Marcar daño",
      vehicleDamageImages: "Imágenes de daños del vehículo",
      incidentDate: "Fecha del incidente",
      incidentTime: "Hora del incidente",
      clear: "Limpiar",
      bookingStatus: "Estado de reserva",
      daysInBooking: "Días en la reserva",
      accumulatedDays: "días acumulados",
      endingThisMonth: "Terminando este mes",
      creditUtilisation: "Utilización de crédito",
      creditLimit: "Límite de crédito",
      utilized: "Utilizado",
      totalDrivers: "Total de conductores",
      vehiclesAllocated: "Vehículos asignados",
      mileageOverview: "Descripción general del kilometraje",
      mileageLimitExited: "Límite de kilometraje",
      approachingMileageLimits: "Acercándose a los límites de kilometraje",
      motReminders: "Recordatorios de MOT",
      totalMotTests: "Pruebas totales de MOT",
      healthCheckReminders: "Recordatorios de chequeo de salud",
      totalHealthCheckTests: "Total de pruebas de chequeo de salud",
      failed: "Fallido",
      serviceReminders: "Recordatorios de servicio",
      overdue: "Atrasado",
      totalServiceReminders: "Recordatorios totales de servicio",
      createNewServiceRequest: "Crear Nueva Solicitud de Servicio",
      serviceDetails: "Detalles del Servicio",
      selectedVehicle: "Vehículo Seleccionado",
      serviceRequestSelectVehicle: "Seleccionar Vehículo",
      loadingVehicles: "Cargando vehículos...",
      noActiveVehiclesFound: "No se encontraron vehículos activos",
      addDetails: "Agregar Detalles",
      addItems: "Agregar Elementos",
      issueType: "Tipo de Problema",
      issueTypePlaceholder: "ej., Cerradura Rota",
      descriptionPlaceholder: "ej., Cerradura de la puerta delantera izquierda",
      uploaded: "Subido",
      additionalComments: "Comentarios Adicionales",
      additionalCommentsPlaceholder: "Agregue cualquier información adicional...",
      submitting: "Enviando...",
      submitRequest: "Enviar Solicitud",
      serviceRequestNote: "Su solicitud será revisada por nuestro equipo de servicio. Recibirá una notificación una vez que sea aprobada o si se necesita información adicional.",
      serviceRequestDetails: "Detalles de Solicitud de Servicio",
      createdDate: "Fecha de Creación",
      estimatedCost: "Costo Estimado",
      requestProgress: "Progreso de Solicitud",
      issuesReported: "Problemas Reportados",
      issue: "Problema",
      imageAlt: "Imagen",
      serviceProvider: "Proveedor de Servicio",
      appointment: "Cita",
      at: "a las",
      estimatedCompletion: "Finalización Estimada",
      workToBeDone: "Trabajo a Realizar",
      cost: "Costo",
      totalCost: "Costo Total",
      requestDeclined: "Solicitud Rechazada",
      communication: "Comunicación",
      serviceTeam: "Equipo de Servicio",
      noCommunicationYet: "Sin comunicación aún",
      addMessage: "Agregar Mensaje",
      askQuestionPlaceholder: "Haga una pregunta o proporcione información adicional...",
      sending: "Enviando...",
      sendMessage: "Enviar Mensaje",
      additionalInformationRequested: "Información Adicional Solicitada",
      provideFollowingInformation: "Por favor, proporcione la siguiente información para ayudarnos a procesar su solicitud:",
      yourAnswer: "Su respuesta:",
      typeAnswerHere: "Escriba su respuesta aquí...",
      submitAnswers: "ENVIAR RESPUESTAS",
      approved: "Aprobado",
      serviceRequests: "Solicitudes de Servicio",
      scheduledServicesTitle: "Servicios programados",
      scheduledServicesBellAria: "Ver servicios programados del vehículo",
      noScheduledServices: "No hay servicios programados",
      approveScheduledServiceSuccess: "Servicio aprobado correctamente",
      requestChangesSuccess: "Solicitud de cambio enviada para aprobación",
      requestChanges: "Solicitar cambios",
      modifyServiceRequest: "Modificar solicitud de servicio",
      modifyDetails: "Modificar detalles",
      vehicleAndCategory: "Vehículo y categoría",
      cannotModify: "No se puede modificar",
      appointmentDetails: "Detalles de la cita",
      time: "Hora",
      scheduledServiceReviewHint: "Revise el servicio programado. Apruebe si los detalles son correctos o solicite cambios.",
      approveService: "Aprobar servicio",
      jobSheet: "Hoja de trabajo",
      declined: "Rechazado",
      lastUpdated: "Última actualización",
      explainChangesPlaceholder: "Explique por qué necesita estos cambios...",
      submitChanges: "Enviar cambios",
      expenses: "Gastos",
      filters: "Filtros",
      applyFilters: "Aplicar Filtros",
      activeFilters: "Filtros Activos",
      newServiceRequest: "Nueva Solicitud de Servicio",
      rowsPerPage: "Filas por página:",
      of: "de",
      moreThan: "más de",
      searchServiceRequestsPlaceholder: "Buscar por número de referencia, vehículo o estado...",
      selectOption: "Seleccionar una opción",
      selectMultiple: "Seleccionar una o más opciones",
      uploadPhoto: "Subir foto",
      view: "Ver",
      typeYourResponse: "Escriba su respuesta",
      pleaseSelectServiceType: "Por favor seleccione un tipo de servicio",
      pleaseSelectServiceCategory: "Por favor seleccione una categoría de servicio",
      selectServiceType: "Seleccionar tipo de servicio",
      serviceCategory: "Categoría de servicio",
      selectServiceCategory: "Seleccionar categoría de servicio",
      unableToDetermineServiceBranch: "No se pudo determinar su sucursal de servicio. Por favor, intente de nuevo más tarde.",
      accidentDamageInformation: "Información de accidente / daño",
      documentUploads: "Carga de documentos",
      adHoc: "Ad-Hoc",
      emergency: "Emergencia",
      serviceQuestionnaire: "Cuestionario de Servicio",
      serviceQuestionnaireDescription: "Proporcione algunos detalles adicionales para que nuestro equipo de servicio pueda preparar todo con anticipación.",
      selectServiceCategoryPrompt: "Seleccione una categoría de servicio para ver las preguntas requeridas para este servicio.",
      noServiceQuestionsForType: "No hay preguntas adicionales para este tipo de servicio. Puede continuar con la solicitud.",
      fileUploadGuidance: "JPEG/PNG hasta 5 MB por archivo.",
      optionalServiceQuestion: "Pregunta opcional — responda si ayuda a nuestro equipo.",
      requestCreated: "Solicitud Creada",
      underReview: "En Revisión",
      inProgress: "En Progreso",
      photo: "Foto",
      hiThere: "Hola,",
      serviceRequestDeclinedMessage: "Hemos revisado su solicitud de servicio, pero no pudo ser aprobada en este momento.",
      whatWeNeed: "Lo que necesitamos:",
      declineReasonGeneric: "Esto puede deberse a detalles faltantes, elegibilidad del servicio u otras condiciones de aprobación.",
      declineInstruction: "Por favor, revise su información y envíe una nueva solicitud una vez que esas actualizaciones estén en su lugar.",
      answered: "Respondido",
      pendingAnswer: "Esperando respuesta",
      requiredField: "Esta respuesta es requerida",
      questionsAnswered: "preguntas respondidas",
      readyToSubmitChanges: "Listo para enviar actualizaciones",
      questionsUpToDate: "Todas las respuestas están actualizadas",
      updateAnyAnswerToResubmit: "Actualice cualquier respuesta arriba si necesita enviar nueva información.",
      answerTypeText: "Texto",
      answerTypeYesNo: "Sí / No",
      answerTypeDropdown: "Menú desplegable",
      answerTypeMultiSelect: "Selección múltiple",
      answerTypeFileUpload: "Carga de foto",
      pendingApproval: "Pendiente de Aprobación",
      awaitingMoreInformation: "Esperando Más Información",
      closed: "Cerrado",
      noServiceRequestsFound: "No se encontraron solicitudes de servicio",
      fleetAllocation: "Asignación de Flota",
      fleetAllocations: "Asignaciones de Flota",
      userAgreement: "Acuerdo de Usuario",
      organisationCode: "Código de la Organización",
      serviceReference: "Referencia del Servicio",
      completionDate: "Fecha de Finalización",
      addTask: "Agregar Tarea",
      noTaskFound: "No se encontraron tareas. Puede agregar tareas manualmente.",
      taskName: "Nombre de la Tarea",
      features: "Características",
      interiorFeatures: "Características Interiores",
      exteriorFeatures: "Características Exteriores",
      safetyAndTechnicalFeatures: "Características de Seguridad y Técnicas",
      otherFeatures: "Otras Características",
      privateHiresNo: "Contrataciones privadas no",
      pcoPrivateHiresHireDLNo: "PCO/contratación privada DL No",
      gender: "Género",
      secondaryEmailAddress: "Dirección de Correo Electrónico Secundaria",
      secondaryPhoneNumber: "Número de Teléfono Secundario",
      driverAge: "Edad del conductor",
      licenceDuration: "Duración de la licencia",
      penaltyPoints: "Puntos de penalización",
      insuranceClaimsHistory: "Historial de reclamaciones de seguros",
      pcoExpiryDate: "Fecha de vencimiento de PCO",
      state: "Estado",
      selectBookingType: "Seleccionar tipo de reserva",
      selectBookingTypeDialog: "Seleccione uno de los siguientes tipos de reserva para continuar con la reserva",
      regularBooking: "Reserva normal",
      contactlessBooking: "Reserva sin contacto",
      reviewBookingDetails: "Revisar los detalles de la reserva",
    },
    validation: {
      otpLengthMismatch: "La longitud de OTP debe ser de 6 caracteres",
      invalidOtp: "OTP no válido",
      required: "{{field}} se requiere",
      billingEmailInvalid:
        "Ingrese un correo electrónico de facturación válido.",
      billingEmailRequired: "Se requiere correo electrónico de facturación.",
      phoneNumberRequired: "Se requiere número de teléfono.",
      businessNameRequired: "Se requiere nombre comercial.",
      registrationNumberRequired: "Se requiere número de registro",
      vatRequired: "Se requiere número de IVA/registro fiscal",
      accountNumberRequired: "Se requiere número de cuenta",
      registeredAddressRequired: "Se requiere la dirección registrada",
      registeredAddressCountryRequired: "Se requiere país",
      registeredAddressStateRequired: "Se requiere estado",
      registeredAddressCityRequired: "Se requiere la ciudad",
      registeredAddressStreetRequired: "Se requiere la calle",
      tradingAddressRequired: "Se requiere la dirección comercial",
      tradingAddressCountryRequired: "Se requiere país",
      tradingAddressStateRequired: "Se requiere estado",
      tradingAddressCityRequired: "Se requiere la ciudad",
      tradingAddressStreetRequired: "Se requiere la calle",
      contactEmailRequired: "Se requiere un correo electrónico de contacto.",
      firstNameRequired: "Se requiere el primer nombre.",
      middleNameRequired: "El segundo nombre es obligatorio.",
      lastNameRequired: "Se requiere apellido.",
      addressRequired: "Se requiere la dirección",
      locationRequired: "Se requiere ubicación",
      streetZipcodeRequired: "Se requiere la calle/ZipCode",
      emailIsRequired: "El correo electrónico es obligatorio",
      termsConditionsAccepted: "Se deben aceptar los términos y condiciones",
      drivingLicenceNumberRequired:
        "Se requiere el número de licencia de conducir",
      nationalInsuranceNumberRequired:
        "Se requiere el número de seguro nacional",
      nationalityRequired: "La nacionalidad es requerida",
      enterValidPhoneNumber: "Ingrese un número de teléfono válido.",
      enterValidEmailAddress:
        "Por favor ingrese una dirección de correo válida",
      authorityRequired: "La autoridad es obligatoria",
      licenceNumberRequired: "Se requiere número de licencia",
      licenceExpiryDateRequired:
        "Se requiere fecha de vencimiento de la licencia",
      expiryDateRequired: "Se requiere la fecha de caducidad",
      numberIsRequired: "Se requiere número",

      passwordLengthValidaion: "La contraseña debe tener al menos 8 caracteres",
      passwordContainUppercase:
        "La contraseña debe contener al menos una letra mayúscula",
      passwordContainLowercase:
        "La contraseña debe contener al menos una letra minúscula",
      passwordContainOneNumber:
        "La contraseña debe contener al menos un número",
      passwordContainSpecialCharacter:
        "La contraseña debe contener al menos un carácter especial",
      passwordMustMatch: "Las contraseñas deben coincidir",
      atleastOneUppercase: "Al menos una letra mayúscula",
      atleastOneLowercase: "Al menos una letra minúscula",
      atleastOneNumericalChar: "Al menos un carácter numérico",
      atleastOneSpecialChar: "Al menos un carácter especial",
      pleaseEnterAValidEmail:
        "Por favor, introduzca un correo electrónico válido",
      driverNotFound: "Conductor no encontrado",
      batteryStatusNumber: "El estado de la batería debe ser un número",
      batteryStatusCantNegative:
        "El estado de la batería no puede ser negativo",
      batteryStatusCantMoreHundred:
        "El estado de la batería no puede ser superior al 100%",
      batteryStatusRequired: "Se requiere el estado de la batería",
      odometerReadingMustNumber: "La lectura del odómetro debe ser un número",
      odometerReadingRequired: "Se requiere lectura del odómetro",
      odometerMustEqualOrHigherLast:
        "La lectura del odómetro debe ser igual o superior a la última registrada",
      titleIsRequired: "Se requiere título.",
      damageKindIsRequired: "Se requiere tipo de daño.",
      descriptionIsRequired: "Se requiere descripción.",
      damageImageIsRequired: "Se requiere imagen del daño.",
      professionIsRequired: "Se requiere profesión",
      passportNineCharacters: "El número de pasaporte debe ser de 9 caracteres",
      passportIsRequired: "Se requiere pasaporte",
      organisationCodeRequired: "Se requiere el código de la organización",
      userNotFound: "Usuario no encontrado",
      invalidPassword: "Contraseña inválida",
      passwordLengthError: "La contraseña debe tener al menos 8 caracteres",
      customerPCONumberRequired: "Se requiere el número PCO / licencia de alquiler privado",
      genderRequired: "El género es obligatorio",
    },
    misc: {
      edit: "Editar",
      logOut: "Cerrar sesión",
      licence: "Licencia",
      cancel: "Cancelar",
      save: "Guardar",
      status: {
        PENDING: "Pendiente",
        APPROVED: "Aprobado",
        DECLINED: "Rechazado",
        IN_REVIEW: "En revisión",
      },
      delete: "Eliminar",
      create: "Crear",
      signIn: "Iniciar sesión",
      select: "Seleccionar",
      back: "Volver",
      error: "Error",
      yes: "Sí",
      no: "No",
      payConfirm: "Pagar y Confirmar",
      clickToAdd: "Haga clic para añadir",
      close: "Cerrar",
      download: "Descargar",
      selectCaps: "SELECCIONAR",
      forgotPassword: "¿Olvidaste tu contraseña?",
      pleaseNote: "Tenga en cuenta",
      front: "Frontal",
      columnKey: {
        "#": "#",
        Particulars: "Detalles",
        Quantity: "Cantidad",
        "Unit Price": "Precio Unitario",
        Duration: "Duración",
        "Discounted Price": "Precio con Descuento",
        "VAT/TAX": "IVA/Impuesto",
        Amount: "Monto",
      },
      columnLabelToKeyMap: {
        ITEM: "ARTÍCULO",
        DESCRIPTION: "DESCRIPCIÓN",
        QUANTITY: "CANTIDAD",
        "UNIT PRICE": "PRECIO UNITARIO",
        DURATION: "DURACIÓN",
        "DISCOUNTED PRICE": "PRECIO CON DESCUENTO",
        "VAT/TAX": "IVA/IMPUESTO",
        PRICE: "PRECIO",
      },
      paymentColumnsKey: {
        Date: "Fecha",
        Amount: "Monto",
        "Mode Of Payments": "Modo de pago",
        Status: "Estado",
      },
      consolidatedInvoicesColumnsKey: {
        "#": "#",
        "Invoice Reference Number": "Número de Referencia de Factura",
        "Vehicle Registration Numbers": "Número(s) de matrícula del vehículo"
      },
      buttonKey: {
        Rentals: "Alquileres",
        Subscriptions: "Suscripciones",
        "Test Drive": "Prueba de Manejo",
        "Contract Hire": "Contrato de Alquiler",
      },
      subLabelKey: {
        "Book vehicle for hours and days": "Reserva vehículo por horas o días",
        "Subscribe vehicle for weekly/monthly":
          "Suscribirse a un vehículo semanal/mensual",
        "Test Drive our Premium Vehicles": "Prueba nuestros vehículos premium",
        "Contract Hire vehicle for weekly/monthly":
          "Contrato de vehículo semanal/mensual",
      },
      buttonTextKey: {
        "Subscribe Now": "Suscribirse Ahora",
        "Book Now": "Reservar Ahora",
        "Contract Now": "Contratar Ahora",
      },
      featuresKey: {
        "Flexible Leasing Options": "Opciones de arrendamiento flexibles",
        "Choose the duration of your subscription as you go":
          "Elige la duración de tu suscripción sobre la marcha",
        "Change car anytime*": "Cambia de coche en cualquier momento*",
        "Home delivery option": "Opción de entrega a domicilio",
        "100% digital": "100% digital",
        "MOT and taxes": "ITV e impuestos",
        "Without down payment": "Sin pago inicial",
        "Vehicle Servicing": "Mantenimiento del vehículo",
      },
      adjustmentColumnKey: {
        "#": "#",
        Amount: "Cantidad",
        "Adjusted To Invoice": "Ajustado a factura",
        "Adjusted At": "Ajustado en",
      },
      categoriesKey: {
        Knowledge: "Conocimiento",
        Behavior: "Comportamiento",
        Punctuality: "Puntualidad",
      },
    },
    snackBar: {
      customerInfoSaved: "Información del cliente guardada",
      documentDeleted: "Documento eliminado con éxito",
      documentDeleteFailed: "No se pudo eliminar el documento",
      documentDeleteError: "Error de eliminación del documento",
      documentMarkedForDeletion:
        "El documento está marcado para eliminarse. Los cambios se aplicarán al guardarlo.",
      profileImageUploaded: "Imagen de perfil cargada correctamente",
      uploadImageFormatError: "¡Solo suba .jpeg/.jpg/.png Formato de imagen!",
      selectDocumentType: "Seleccione el tipo de documento",
      selectExpiryDate: "Seleccione la fecha de vencimiento del documento",
      fileSizeExceeded50mb: "El tamaño del archivo excedió el límite de 50 MB",
      fileSizeExceeded5mb: "El tamaño del archivo excedido del límite de 5 MB",
      uploadSuccess: "Documento cargado con éxito",
      invalidUploadFormat: "Solo suba los archivos PDF, PNG, JPG o JPEG",
      selectExpiryDateUpload:
        "Seleccione una fecha de vencimiento antes de cargar",
      ImageUploaded: "Imagen subida correctamente",
      invalidFileType: "Tipo de archivo inválido. Tipos permitidos: jpeg o png",
      costCenterInfoMissing: "¡Falta la información del centro de costos!",
      selectedDriverAlreadyAdded:
        "El conductor seleccionado ya ha sido agregado.",
      driverSavedSuccessfully: "Conductor guardado con éxito.",
      additionalDriverCannotBeMore:
        "Los conductores adicionales no pueden ser más que la cantidad de complementos",
      verificationStatusInReview: "El estado de verificación está en revisión",
      verificationStatusPending: "El estado de verificación está pendiente",
      quoteCreated: "Cotización creada",
      bookingCreated: "Reserva creada",
      pickUpLocationEmpty: "La ubicación de recogida está vacía",
      slotSelectionRequiredForNonNegotiable:
        "Se requiere la selección de franja horaria.",
      protectionPlanMandatoryForPCOBooking:
        "El plan de protección es obligatorio para esta reserva",
      paymentAlreadyDone: "Pago ya realizado",
      fileBeingGenerated:
        "Archivo en proceso de generación, por favor intente más tarde",
      provideDeliveryAddress: "¡Por favor proporcione la dirección de entrega!",
      noValidCreditReadingFound:
        "No se encontró una lectura de crédito válida para esta empresa.",
      noValidCreditScoreFound:
        "No se encontró un puntaje de crédito válido. Puede deberse a que se ha superado el límite de verificaciones.",
      atleastOneLicenceImage: "Suba al menos una imagen de la licencia",
      licenceImageUploaded: "Imagen de licencia subida exitosamente",
      maximumTwoImageLicence:
        "¡Solo se pueden subir dos imágenes como máximo para la licencia!",
      imageUploadInProgress: "Espere, la imagen se está subiendo",
      errorFetchingSignedUrl: "Error al obtener la URL firmada",
      paymentFailed: "El pago ha fallado, inténtalo de nuevo",
      paymentFailedReasonCardDetails:
        "¡Tu pago ha fallado! Verifica los datos de tu tarjeta o inténtalo más tarde.",
      maximumTwoImage: "Se pueden subir un máximo de dos imágenes para",

      cancelledSuccessfully: "Cancelado con éxito",
      selectReasonForCancel:
        "Por favor, introduzca el motivo de la cancelación",
      streetZipcodeRequired: "Calle / Código postal es obligatorio",
      feedbackSaved: "¡Gracias! Tus comentarios han sido guardados",
      driverAlreadyAdded: "¡El conductor ya ha sido agregado!",
      driverRemoved: "Conductor eliminado con éxito",
      businessCustomerDriverDeleted:
        "Conductor de cliente comercial eliminado.",
      errorInSavingData: "Error al guardar los datos",
      damageInformationSaved: "Información de daños guardada con éxito.",
      errorSavingData: "Error al guardar datos",
      problemTelematicsData: "Problema al cargar los datos telemáticos",
      verificationRequestSent: "Solicitud de verificación enviada con éxito.",
      vehicleStateUpdated: "Estado del vehículo actualizado",
      driverAdded: "Conductor agregado.",
      businessCustomerCreated: "Cliente empresarial creado.",
      uploadOnlyImageFiles: "Por favor, suba solo archivos de imagen (PNG, JPEG, JPG)",
      imageSizeExceed5MB: "El tamaño de la imagen no debe superar los 5MB",
      uploadFailed: "Error al cargar",
      imagesUploadedSuccessfully: "imagen(es) subida(s) con éxito!",
      failedToUploadImages: "Error al subir imágenes. Por favor, inténtelo de nuevo.",
      pleaseSelectVehicle: "Por favor, seleccione un vehículo",
      pleaseFillInAllIssueDetails: "Por favor, complete todos los detalles del problema",
      serviceRequestCreatedSuccessfully: "¡Solicitud de servicio creada con éxito! Referencia:",
      errorCreatingServiceRequest: "Error al crear la solicitud de servicio",
      pleaseEnterNote: "Por favor, ingrese una nota",
      noteAddedSuccessfully: "Nota agregada con éxito",
      errorAddingNote: "Error al agregar nota",
      pleaseAnswerAllRemainingQuestions: "Por favor, responda todas las {{count}} pregunta{{plural}} restantes",
      answersSubmittedSuccessfully: "¡Respuestas enviadas con éxito! Su solicitud está ahora bajo revisión.",
      errorSubmittingAnswers: "Error al enviar respuestas",
      serviceRequestNotFound: "Solicitud de servicio no encontrada",
      errorLoadingServiceRequests: "Error al cargar solicitudes de servicio",
      oneVehicleForContactless: "Solo se puede seleccionar un vehículo para una reserva sin contacto",
      oneVehicleForNonContactless: "Solo se puede seleccionar un vehículo sin contacto o Smartcar para una reserva sin contacto",
      contactlessVehicleCannotBeSelected: "No se puede seleccionar un vehículo sin contacto para reservas normales",
      bookingDetailsCreated: "Detalles de la reserva creados"
    },
  },
};